// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles__overlay--2fdi5"};
    if(module.hot) {
      // 1545480338358
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  